import {
  FC,
  RefObject,
  createContext,
  useCallback,
  useContext,
  useMemo,
  useRef,
  useState,
} from 'react';

import { useAppContext } from '@contexts/AppContext';

import { useFetchCurrentUserGagglRank } from '@queries/CritiqueQueries';
import { useCurrentEntertainerQuery } from '@queries/EntertainerQueries';

import { FormLabel } from '@components/form/FormLabel';

import { AuthPopupEntertainer, EntertainerLoginContent } from './EntertainerLoginContent';
import { AuthPopup, AuthPopupProps, useAuthState } from './LogInScreen';

interface CreateAuthGateHandlerFnOptions {
  authMessage?: string;
  authTitle?: string;
  entertainerCallback?: (entertainerProperies: AuthPopupEntertainer) => void;
  cityId?: string;
  categories?: string[];
  allowNonEntertainer?: boolean;
  entertainerType?: string;
  authBeforeEntertainerSignup?: boolean;
  isUserOnboarding?: boolean;
  onAuthCancelled?: () => void;
}
export type CreateAuthGateHandlerFn = (
  callback: () => void,
  options?: CreateAuthGateHandlerFnOptions,
) => void;

export const AuthGateContext = createContext<{
  createAuthGateHandler: CreateAuthGateHandlerFn;
}>({ createAuthGateHandler: () => {} });

export const useAuthGate = () => useContext(AuthGateContext);
